import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import {
  Link,
  LinkIcon,
} from '../../components'
import Styles from './SjfIssueCards.css'

@CSSModules(Styles, {allowMultiple:true})
export default class SjfIssueCards extends Component {
  render() {
    return <Row>
      {
        [
          [
            'Gender Equality',
            'Investing in gender equality means supporting fair pay, representation, and workplaces where women can thrive.',
            'aboutGef'
          ],
          [
            'Diversity Disclosures',
            'Diversity isn’t just good business – it’s about fairness and belonging. When every voice is valued, workplaces thrive and innovation flourishes.',
            'aboutDei'
          ],
          [
            'Racial Justice',
            'Companies make big promises on racial justice, but who’s living up to them? Investing in those turning words into action can drive lasting change.',
            'aboutRji'
          ],
          [
            'LGBTQ+ Equity',
            'Everyone deserves to live and work with pride. Companies that respect and uplift all identities help create a world where everyone belongs.',
            'aboutHrc'
          ],
        ].map((e, i) => {
          return <Col xs={12} sm={6} md={3} lg={3} key={'sjf-issue-card--'+i}>
            <div styleName='issue-card'>
              <div styleName={'issue-card__image issue-card__image--'+i}>
              </div>
              <div styleName='issue-card__content'>
                <h3 styleName='issue-card__label'>
                  {e[0]}
                </h3>
                <p styleName='issue-card__copy'>
                  {e[1]}
                </p>
                <div styleName={'issue-card__link issue-card__link--'+i}>
                  <Link to={config.routes[e[2]]} title={e[0]}>
                    More<LinkIcon />
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        })
      }
    </Row>
  }
}
